import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
  Flex,
  Icon,
  Text,
  Center,
  Spinner,
} from '@chakra-ui/react'
import React, { useEffect, useRef } from 'react'
import { Button } from '../../../../../../components/Button'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import { ProductList } from './ProductList'
import Input from '../../../../../../components/Input'
import { Menu } from './Menu'
import { api } from '../../../../../../services/api'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { formatPrice } from '../../../../../../utils/formatPrice'
import { useParams } from 'react-router-dom'
import { useOrcamentoPedido } from '../../../../../../contexts/OrcamentoPedidoProvider'

async function getSubcategorias() {
  const { data } = await api.get(`/site/v2/categoria/listar-subcategorias`)

  return data
}

async function addItems({ item }) {
  const response = await api.post('/site/v2/orcamento-crm/inserir-produtos-orcamento', item)

  return response.data
}

async function getProductsSubcategory({ subcategory, produto, quantidade }) {
  const { data } = await api.get(`/site/v2/orcamento-crm/busca-produtos-orcamento-crm`, {
    params: {
      produto,
      codigo_grupo_produto: subcategory,
      quantidade,
    },
  })

  return data
    .map((item) => {
      const hasColor = item.cores.some((cor) => parseInt(cor.quantidade_disponivel) > 0)

      return {
        ...item,
        preco_home: formatPrice(item.preco_home),
        id: item.codigo_produto,
        isShowOrcamento: true,
        original_preco_home: item.preco_home,
        disponivel: hasColor,
      }
    })
    .sort((a, b) => {
      //por ultimo seempre disponiveis = false, depois por preco (do menor para o maior)
      if (a.disponivel && !b.disponivel) {
        return -1
      }

      if (!a.disponivel && b.disponivel) {
        return 1
      }

      //transforma em numero para ordenar
      return parseFloat(a.original_preco_home) - parseFloat(b.original_preco_home)
    })
}

export function ModalProdutos({ itens, infoProposta }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { pedidoBloqueado } = useOrcamentoPedido()
  const btnRef = React.useRef()
  const [subCategorySelected, setSubCategorySelected] = React.useState(null)
  const [productsSelected, setProductsSelected] = React.useState([])
  const { numeroProposta: numProposta } = useParams()

  const quantityRef = useRef()

  const [searchInput, setSearchInput] = React.useState('')
  const [quantity, setQuantity] = React.useState('')

  const searchInputRef = useRef()

  const queryClient = useQueryClient()

  const configQuery = {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24,
  }

  const { data: listSubcategorias = [] } = useQuery({
    ...configQuery,
    queryKey: ['products'],
    queryFn: getSubcategorias,
    enabled: !!isOpen,
    onSuccess: (data) => {},
  })

  const { mutateAsync: addProducts, isLoading: addProductsLoading } = useMutation({
    mutationFn: addItems,
    onSuccess: (data) => {
      const productsInsert = data?.map((item) => {
        return {
          ...item,
          id: `${item.codigo_produto}-${parseInt(Math.random() * new Date().getTime())}`,
          original_preco_venda: 0, // Iniciar zerado
          original_valor_total_itens: 0, // Iniciar zerado
          original_preco_base: item.valor_unitario,
          valor_total_itens: formatPrice(0), // Iniciar zerado
          preco_base: formatPrice(item.valor_unitario),
          preco_site: formatPrice(item.preco_site),
          preco_venda: formatPrice(0), // Iniciar zerado
          vlr_substituicao: formatPrice(item.vlr_substituicao),
          original_vlr_substituicao: item.vlr_substituicao,
          prazo: item.prazo,
          prazos: item.prazos.map((prazo) => {
            return {
              value: parseInt(prazo.prazo),
              label: `${prazo.prazo} dias úteis`,
            }
          }),
          impressoes: item.impressoes.map((impressao) => {
            return {
              value: parseInt(impressao.qtd_batida),
              label: `${impressao.qtd_batida} impressões`,
            }
          }),
          personalizacao: item.personalizacao.map((personalizacao) => {
            return {
              value: parseInt(personalizacao.id_personalizacao),
              label: personalizacao.nome_personalizacao,
              caricatura: personalizacao.caricatura_ativa,
            }
          }),
          cores: item.cores.map((cor) => {
            return {
              ...cor,
              value: parseInt(cor.codigo_cor),
              label: cor.descricao_cor,
              hex: cor.rgb_cores,
            }
          }),
        }
      })

      queryClient.setQueryData(['items', numProposta], (old) => {
        return {
          ...old,
          itens: [...old.itens, ...productsInsert],
          informacao_da_proposta: {
            ...old.informacao_da_proposta,
            calc_kangu: data[0].calc_kangu,
            comissao_prevista: data[0].comissao_prevista,
          },
        }
      })

      // queryClient.invalidateQueries('items');

      onClose()
    },
  })

  const { data: products = [], isLoading: isLoadingProducts } = useQuery({
    ...configQuery,
    queryKey: ['products', subCategorySelected, searchInput, quantity],
    queryFn: () =>
      getProductsSubcategory({
        subcategory: subCategorySelected?.codigo_grupo_produto,
        produto: searchInput,
        quantidade: quantity,
      }),
    enabled: !!isOpen && !!(subCategorySelected || searchInput || quantity),
  })

  function handleSelectProduct(product) {
    const existingProduct = productsSelected.find((item) => item.codigo_produto === product.codigo_produto)

    if (existingProduct) {
      setProductsSelected((prev) => prev.filter((item) => item.codigo_produto !== product.codigo_produto))

      return
    }

    setProductsSelected((prev) => [...prev, product])
  }

  async function onConfirmProductsSelected() {
    const params = {
      numero_nota: infoProposta?.num_proposta,
      codigo_vendedor: infoProposta.codigo_vendedor,
      codigo_parceiro: infoProposta.cliente.codigo_parceiro,
      email_parceiro: infoProposta.email_parceiro,
      telefone_parceiro: infoProposta.telefone_parceiro || infoProposta.cliente.telefone,
      nome_parceiro: infoProposta.nome_parceiro,
      produtos: productsSelected?.map((item) => {
        return {
          id: `${item.codigo_produto}-${parseInt(Math.random() * new Date().getTime())}`,
          codigo_produto: item.codigo_produto,
          quantidade: 0,
          valor_unitario: 0, // Alterado para iniciar zerado
          valor_total: 0, // Mantido zerado
          qtd_batida: 0,
          id_impressao: null,
          codigo_cor: null,
          prazo: 0,
          frete_site: null,
        }
      }),
    }

    await addProducts({ item: params })
  }

  function onSubmitSearch(event) {
    event.preventDefault()

    setSearchInput(searchInputRef.current.value)
    setQuantity(quantityRef.current.value)
  }

  useEffect(() => {
    if (!isOpen) {
      setProductsSelected([])
    }
  }, [isOpen])

  useEffect(() => {
    //toda vez q mudar a categoria, zera quantidade e busca produtos
    setQuantity('')
    setSearchInput('')
  }, [subCategorySelected])

  return (
    <>
      <Button my="3" display="flex" ml="auto" maxW="181px" w="100%" onClick={onOpen} ref={btnRef} pointerEvents={pedidoBloqueado ? 'none' : 'auto'}>
        add produto(s)
      </Button>
      <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <DrawerHeader maxW="1200px" w="full" mx="auto" px={0}>
            <Flex alignItems="center" justifyContent="space-between" mb={2} gap="20px">
              <Menu
                list={listSubcategorias}
                onSelect={(subcategory) => {
                  setSubCategorySelected(subcategory)
                }}
                selected={subCategorySelected?.descricao_grupo_produto}
              />

              <Flex alignItems="end" justifyContent="center" flex={1} as="form" onSubmit={onSubmitSearch}>
                <Input placeholder="Buscar por nome ou Código do produto..." borderRadius="0" ref={searchInputRef} name="search" />
                <Input ml="2" mr={2} placeholder="Filtrar quantidade" borderRadius="0" ref={quantityRef} name="quantity" maxW="200px" />

                <Button borderRadius="0" w="181px" bgColor="#378BBF" type="submit">
                  Buscar
                </Button>
              </Flex>
            </Flex>
          </DrawerHeader>
          <DrawerBody maxW="1200px" w="full" mx="auto" p={0}>
            {isLoadingProducts && (
              <Center>
                <Text textAlign="center" fontSize="20px" color="#707070" fontWeight="semibold" mt="10" textTransform={'uppercase'}>
                  Carregando produtos da categoria{' '}
                  <Text as="span" color="#378BBF" fontWeight="bold">
                    {subCategorySelected?.descricao_grupo_produto}
                  </Text>
                  ... <Spinner color="blue.500" />
                </Text>
              </Center>
            )}
            <ProductList list={products} handleSelectProduct={handleSelectProduct} selectedProducts={productsSelected} />
          </DrawerBody>
          <DrawerFooter position="sticky" bottom="0" boxShadow="0px -1px 4px rgba(0, 0, 0, 0.1)">
            <Flex alignItems="center" justifyContent="space-between" maxW="1200px" w="full" mx="auto">
              <Button variant="outline" mr={3} onClick={onClose} w="181px" bg="transparent" color="#378BBF">
                <Icon as={AiOutlineArrowLeft} mr={2} color="#378BBF" />
                Voltar
              </Button>
              <Text color="#707070" fontSize="20px">
                Adicionados:{' '}
                <Text color="#378BBF" as="span" fontWeight="semibold">
                  {productsSelected.length} produto(s)
                </Text>{' '}
              </Text>
              <Button w="181px" onClick={onConfirmProductsSelected} isLoading={addProductsLoading}>
                add produtos(s)
              </Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}
